import { render, staticRenderFns } from "./Subsystems.vue?vue&type=template&id=47be7967&scoped=true"
import script from "./Subsystems.vue?vue&type=script&lang=js"
export * from "./Subsystems.vue?vue&type=script&lang=js"
import style0 from "./Subsystems.vue?vue&type=style&index=0&id=47be7967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be7967",
  null
  
)

export default component.exports